export function generarMensaje(filas) {
  if (!filas.length) return "";

  const saludo = getSaludo();
  const agrupado = {};

  // Agrupar por serieLote
  for (const fila of filas) {
    const clave = fila.serieLote;
    if (!agrupado[clave]) agrupado[clave] = [];
    agrupado[clave].push(fila);
  }

  let mensaje = `*${saludo}, les comparto los precios de MAYOREO:*\n`;

  for (const lote in agrupado) {
    const grupo = agrupado[lote];
    const encabezado = grupo[0];

    mensaje += `\n*${encabezado.serieLote} ${capitalize(encabezado.especie)} ${encabezado.emoji || ""} ${encabezado.etiqueta}*\n`;

    for (const fila of grupo) {
      const dif = fila.Dif === "N/A" ? "-" : fila.Dif;
      const especial = fila.precioEspecial ? ` / *Precio especial: $${fila.precioEspecial}*` : "";
      mensaje += `${fila.transito} cjs - ${fila.calibre} ${fila.calidad} ${dif} ${fila.empaque} ${fila.variedad} $${fila.mayoreo}${especial}\n`;
    }
  }

  return mensaje.trim();
}

function getSaludo() {
  const hora = new Date().getHours();
  if (hora < 12) return "Buenos Días";
  if (hora < 20) return "Buenas Tardes";
  return "Buenas Noches";
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
